

import home_image from "../assets/home/home_image.png"
import bg_service from "../assets/home/bg_service.jpg"

import Header from "../components/header"

import { motion } from "framer-motion"
import { useSiteContent } from "../contexts/siteContentContext";
import Service from "../components/service"

import { TbCheckupList } from "react-icons/tb";
import { MdOutlineVaccines } from "react-icons/md";
import { RiScissorsFill } from "react-icons/ri";
import { TbDental } from "react-icons/tb";
import { FaPhone } from "react-icons/fa";
import { FaEnvelope } from "react-icons/fa";
import { FaHouse } from "react-icons/fa6";
import { FaArrowCircleRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom"
import Product from "../components/product"

import { productsList } from "../config/ProductsList"
import { useState } from "react"

export default function Home() {
    const [loading, setLoading] = useState(false);
    const { getContent } = useSiteContent();

    const navigate = useNavigate();
    const apiUrl = process.env.REACT_APP_API_URL;

    const handleAppointmentClick =() => {
        navigate('/set-appointment');
    }

    const onContactSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        setLoading(true);
        const formData = Object.fromEntries(new FormData(e.currentTarget).entries());

        await fetch(`${apiUrl}/api/contact`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
        .then(async (res) => {
            const responseData = await res.json();
            if (res.ok) {
                alert(responseData.message);

                if (e.currentTarget) e.currentTarget.reset();
                
            } else {
                alert(`Error: ${responseData.message || 'Failed to send message.'}`);
            }
        }).catch((err) => {
            alert(`Error: ${err.message || 'Failed to send message.'}`);
        }).finally(() => {
            setLoading(false);
        })
    }

    return (
        <>
        <title>{getContent("settings.page_title", "Pet Medics - Veterinary Clinic")}</title>
        <Header />

        <main className="h-screen w-full max-w-full top-16 md:top-20 pt-4 md:pt-8 bg-gradient-to-b from-[#1BA3AB] to-[#145956]">
            <section id="home" className="w-full min-h-screen flex flex-col md:flex-row md:justify-normal justify-center items-center">
                <img src={home_image} alt="Home Image" className="w-full h-screen object-cover object-center md:h-full"></img>

                <motion.div className="w-full self-center md:w-1/2 md:ml-12 h-full absolute flex flex-col justify-center items-center px-4 md:px-8 text-center md:text-left"
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                >
                    <h1 className="text-4xl md:text-5xl font-bold text-white drop-shadow-lg mb-4">{getContent("hero.main_title", "Comprehensive Pet Care at Your Fingertips")}</h1>
                    <p className="text-lg md:text-xl text-white drop-shadow-md mb-6">{getContent("hero.main_subtitle", "Your one-stop solution for all your pet's health needs. Schedule appointments, access medical records, and get expert advice from licensed veterinarians.")}</p>
                    <motion.button
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                    className="mt-4 md:mt-0 bg-brand-primary-500 hover:bg-brand-primary-600 text-white py-3 px-6 text-lg rounded-md shadow-lg transition-all duration-200 ease-out md:self-start"
                    onClick={handleAppointmentClick}>{getContent("hero.appointment_button", "Set An Appointment")} <FaArrowCircleRight className="inline ml-2"/> </motion.button>
                </motion.div>
            </section>

             <section id="products" className="min-h-screen w-full bg-gradient-to-b px-6 md:px-32 from-[#145956] to-[#0E3B3E] items-center justify-center flex flex-col py-12">
                {/* Products Section */}
                <motion.div
                    className="w-full text-white"
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }}
                >
                    <h2 className="text-2xl md:text-3xl font-bold drop-shadow-lg text-center mb-8">{getContent("products.title", "Our Products")}</h2>
                    <p className="text-center mb-8">{getContent("products.subtitle", "Explore our range of high-quality pet care products designed to keep your furry friends happy and healthy.")}</p>

                    <div className="w-full grid grid-cols-1 md:grid-cols-3 gap-6 place-content-center place-items-center justify-center">
                        {productsList.map((product, idx) => (
                            <Product
                                key={idx}
                                img={product.img}
                                title={product.title}
                                description={product.description}
                                price={product.price}
                            />
                        ))}
                    </div>
                </motion.div>
            </section>


            <section id="about" className="min-h-screen w-full text-center flex flex-col justify-center items-center bg-gradient-to-b px-6 md:px-32 from-[#145956] to-[#0E3B3E]">
                {/* About Section */}
                <motion.div
                    className="w-full"
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }}
                    viewport={{ once: true }}>
                    <h2 className="text-2xl md:text-3xl font-bold text-white drop-shadow-lg text-center mb-8">{getContent("about.title", "About Us")}</h2>
                    <p className="text-md md:text-lg text-white drop-shadow-md mb-6">{getContent("about.paragraph1", "Pet Medics Veterinary Clinic is a trusted veterina...")}</p>
                    <p className="text-md md:text-lg text-white drop-shadow-md mb-6">{getContent("about.paragraph2", "We are dedicated to providing the best care...")}</p>
                </motion.div>
            </section>

            <section id="services" className="min-h-screen w-full text-center flex flex-col justify-center items-center bg-gradient-to-b px-6 md:px-32 from-[#0E3B3E] to-[#082726]">
                {/* Services Section */}
                <img src={bg_service} alt="Background Service" className="absolute w-full h-full object-cover opacity-20 pointer-events-none"></img>

                <motion.div
                    className="w-full text-white"
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }}
                    viewport={{ once: true }}
                >
                    <h2 className="text-2xl md:text-3xl font-bold drop-shadow-lg text-center mb-8">{getContent("services.title", "Our Services")}</h2>
                </motion.div>
                <motion.div
                    className="w-full grid grid-cols-1 md:grid-cols-3 gap-6 place-content-center place-items-center justify-center text-white"
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                >
                    <Service
                        icon={<TbCheckupList className="text-4xl mx-auto mb-4"/>}
                        title={getContent("services.checkup_title", "General Check-ups")}
                        description={getContent("services.checkup_desc", "Comprehensive health examinations...")}
                        />
                    <Service 
                        icon={<MdOutlineVaccines className="text-4xl mx-auto mb-4"/>}
                        title={getContent("services.vaccination_title", "Vaccinations")}
                        description={getContent("services.vaccination_desc", "Stay up-to-date...")}
                    />
                    <Service 
                        icon={<RiScissorsFill className="text-4xl mx-auto mb-4"/>}
                        title={getContent("services.grooming_title", "Grooming Services")}
                        description={getContent("services.grooming_desc", "Professional grooming...")}
                    />
                    <Service 
                        icon={<TbDental className="text-4xl mx-auto mb-4"/>}
                        title={getContent("services.dental_title", "Dental Care")}
                        description={getContent("services.dental_desc", "Dental care services...")}
                        additional="col-span-full"
                    />
                </motion.div>
            </section>
            

            <section id="contact" className="min-h-screen mt-11 w-full text-center flex flex-col justify-center items-center bg-gradient-to-b px-6 md:px-32 from-[#fbfbfb] to-black]">
                {/* Contact Section */}
                <motion.div
                    className="w-full text-[#444444]"
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }}
                >
                    <h2 className="text-lg md:text-xl font-semibold text-center mb-1">{getContent("contact.title", "Contact Us")}</h2>
                    <p className="text-sm md:text-md drop-shadow-md mb-8">{getContent("contact.subtitle", "Have questions or need assistance?...")}</p>
                    
                    <div className="flex flex-col md:flex-row gap-4 justify-center items-center">
                        <div className="flex flex-col md:max-w-sm">
                            <div className="flex flex-col text-left">
                                <h3 className="text-lg mb-4">{getContent("contact.address_label", "ADDRESS")}</h3>
                                <p className="text-sm md:text-md drop-shadow-md"><FaHouse className="inline mr-1" /> {getContent("contact.address", "Blk98 L8b, C.Arellano St. Ph2. Katarungan Village, Poblacion, Muntinlupa City")}</p>
                            </div>
                            <div className="flex flex-col text-left">
                                <h3 className="text-lg mb-4 mt-4">{getContent("contact.contact_label", "CONTACT")}</h3>
                                <p className="text-sm md:text-md drop-shadow-md"><FaPhone className="inline mr-1"/> {getContent("contact.phone", "(+63) 968 388 2727")}</p>
                                <p className="text-sm md:text-md drop-shadow-md"><FaEnvelope className="inline mr-1"/> {getContent("contact.email", "petmedicsvetclinic21@gmail.com")}</p>
                            </div>
                        </div>
                        <div className="flex flex-col w-full md:w-3/4">
                            <form onSubmit={onContactSubmit}>
                                <div className="flex flex-col text-left mb-4">
                                    <label htmlFor="name" className="mb-2">Name *</label>
                                    <input type="text" id="name" name="name" placeholder="Enter your name" className="w-full p-3 font-light text-sm border border-gray-300 bg-black/5 rounded-md" required/>
                                </div>
                                <div className="flex flex-col text-left mb-4">
                                    <label htmlFor="email" className="mb-2">Email *</label>
                                    <input type="email" id="email" name="email" placeholder="Enter your email" className="w-full p-3 font-light text-sm border border-gray-300 bg-black/5 rounded-md" required/>
                                </div>
                                <div className="flex flex-col text-left mb-4">
                                    <label htmlFor="message" className="mb-2">Message *</label>
                                    <textarea id="message" name="message" rows={4} placeholder="Enter your message" className="w-full p-3 font-light text-sm border border-gray-300 bg-black/5 rounded-md" required></textarea>
                                </div>

                                <motion.button
                                    whileHover={{ scale: 1.05 }}
                                    whileTap={{ scale: 0.95 }}
                                    type="submit"
                                    disabled={loading}
                                className="disabled:cursor-not-allowed cursor-pointer mt-4 md:mt-0 bg-brand-primary-500 hover:bg-brand-primary-600 disabled:bg-brand-primary-900 text-white font-semibold py-3 px-6 text-lg rounded-md shadow-lg transition-all duration-200 ease-out">{`${loading ? 'Sending...' : getContent("contact.send_button", "Send Message")}`}</motion.button>
                            </form>                        
                        </div>
                    </div>
                </motion.div>
            </section>

            <footer className="w-full mt-8 h-16 bottom-0 relative">
                <div className="w-full h-full bg-[#145956] flex justify-center items-center">
                    <p className="text-white text-center text-sm md:text-md">{getContent("footer.copyright", "© 2025 Pet Medics Veterinary Clinic. All rights reserved.")}</p>
                </div>
            </footer>   
            </main>
        </>
    )
}